import { AxiosResponse } from 'axios';
import React from 'react';

export interface IValueState<T> {
    value?: T;
    set: (newValue?: T) => void;    
}

export function useValueState<T>(initialValue?: T) {
    const [_value, _setValue] = React.useState<T | undefined>(initialValue);

    const set = React.useCallback((newValue: T | undefined) => {
        if (newValue !== _value) {
            _setValue(newValue);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleResponse = React.useCallback((response: AxiosResponse<T>) => {
        _setValue(response.data);
    }, []);

    return React.useMemo(() => ({
        value: _value,
        set, handleResponse
    }), [_value, set, handleResponse]);
}